export const MODULE_NAME = 'scheduled-reports';
export const REPORT_SCHEDULE_ROUTE = `/${MODULE_NAME}`;
